import { makeVar } from "@apollo/client";

export const educationVar = makeVar({});
export const employmentVar = makeVar({});
export const paymentVar = makeVar({});
export const talentVar = makeVar({});
export const titleOverviewVar = makeVar({});
export const profileVar = makeVar({});
